<template>
  <v-container style="margin-top:0px; padding-top:0px;">

    <v-row v-if="page">
      <v-col>
        <div v-html="page.html">

        </div>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'page',
  components: {

  },
  data: () => ({
    page: null
  }),
  mounted () {
    this.getPageBySlug(this.$route.params.slug)
  },
  methods: {
    async getPageBySlug(slug) {
      return axios.get(process.env.VUE_APP_ROOT_API + '/page/' + slug, {
        params: {
          locale: this.$store.state.app.locale.code,
          channel: this.$store.state.app.channel.code,
          currency: this.$store.state.app.currency.code,
        }
      }
      ).then(response => {
        this.page = response.data.data;
      }).catch(error => {
        console.log(error);
      })
    },
  }
};
</script>


<style scoped>

</style>
